/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ years: NonNullable<unknown> }} Consumption_Comparison_Previous_YearsInputs */



/**
* | output |
* | --- |
* | "Same period Y-{years}" |
*
* @param {Consumption_Comparison_Previous_YearsInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const consumption_comparison_previous_years = /** @type {((inputs: Consumption_Comparison_Previous_YearsInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consumption_Comparison_Previous_YearsInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ (`Same period Y-${i?.years}`)
	return /** @type {LocalizedString} */ (`Même période N-${i?.years}`)
});